module.exports = __webpack_public_path__ + "media/src/images/balloons/blue_gradient-93a7c35341ad09f0a4792b0236ed9165.png";